import { DateString, DateTimeString, PersonAge } from '@shared/core/types';
import format from 'date-fns/format';
import parse from 'date-fns/parse';
import differenceInYears from 'date-fns/differenceInYears';
import addYears from 'date-fns/addYears';
import differenceInMonths from 'date-fns/differenceInMonths';
import { DATE_LOCALES } from '@shared/i18n-locales';

export function formatDate(
  date: Date | number,
  dateFormat: string,
  locale = 'ru',
): string | DateTimeString | DateString {
  return format(date, dateFormat, { locale: DATE_LOCALES[locale] });
}

export function getPersonAge(birthday: DateString, dateFormat: string): PersonAge {
  const theDate = parse(birthday, dateFormat, new Date());
  const now = new Date();

  const years = differenceInYears(now, theDate);
  const theDatePlusYears = addYears(theDate, years);
  const months = differenceInMonths(now, theDatePlusYears);

  return {
    years,
    months,
  };
}

export function getLastDayOfPrevYear(): Date {
  return new Date(new Date().getFullYear() - 1, 11, 31);
}
